import Vue from 'vue/dist/vue.esm'

Vue.component(
  'tirant-workspace-wrapper-vue',
  () => import(/* webpackChunkName: "[request]" */ 'components/tirant_workspace/Wrapper')
)
